import { Action, defaultActions } from '#/common/components/DataGrid';
import { AssetType } from '#/graphql/types';

export const actions: Action<AssetType>[] = [...defaultActions];
